export default __webpack_public_path__ + "static/media/partners-7.bd6aae92.png";